import { Container, Typography } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet-async";

import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Container style={{ marginTop: "240px" }}>
      <Helmet title='Not Found | Assets Register' />
      <Typography
        style={{ marginBottom: "90px", textDecoration: "italic" }}
        variant='h3'>
        <em> Oops! That page can’t be found.</em>
      </Typography>
      <Typography variant='h5'>
        Sorry It looks like nothing was found at this location <br />
        <Link to={"/assets-register"} style={{ color: "blue" }}>
          go home
        </Link>
      </Typography>
    </Container>
  );
}
